<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
// 용어해석 - 일간 & 오행분포
import { VCol, VRow } from 'vuetify/lib/components/index.mjs';
// components
import KeywordExplanation from './KeywordExplanation.vue';
import SummarySajuBirth from './SummarySajuBirth.vue';
import SajuFiveStart from '@/components/saju-insight/ohaeng/SajuFiveStart.vue';
import { useAnalysisDataStore } from '@/store/modules/analysisDataStore';

const {
  transdata,
  birthData,
  birthEightTxt,
  birthJijanggan,
  curDaeun,
} = storeToRefs(useAnalysisDataStore())

const ManseBirthMainArea = ref(null)
const starRef = ref(null)
const langMode = ref('CHNKOR')
const birthTitle = ref('시일월년')
// 일간에 active
const selectedData = ref(2)
const isActive = ref(true)
</script>

<template>
<VRow class="ss-full-height">
  <VCol cols="12" :md="halfCol" class="ss-full-height">
    <div class="summ-card right">
      <section class="summ-body">
        <KeywordExplanation
          chn="日"
          tit="일간 (나)"
          subtit="사주의 주인공입니다."
          :desc="[
            '열가지 천간 중 <b>어떤 기운으로 태어났는지를 말해요.</b>',
            '내가 어떤 성향을 타고 났는지, 기본 기질을 보여주는 핵심입니다.'
            ]"
          :bottom="['갑목은 큰 나무, 기토는 촉촉한 흙처럼 기질을 담고있습니다.']"
          :ex-string="true"
        />
        <div class="summ-body__saju">
          <SummarySajuBirth
            :pr-birth-data="birthData"
            :pr-birth-jijanggan="birthJijanggan"
            :pr-lang-mode="langMode"
            :pr-birth-title="birthTitle"
            :pr-transdata="transdata"
            :pr-type="'birth'"
            :pr-cur-daeun="curDaeun"
            :selected-data="selectedData"
            :is-active="isActive"
            :active-page="'page1'"
          />
        </div>
      </section>
    </div>
  </VCol>
  <VCol cols="12" :md="halfCol" class="ss-full-height">
    <div class="summ-card">
      <section class="summ-body">
        <KeywordExplanation
          chn="五"
          tit="오행분포"
          subtit="내 안의 기운의 균형을 보여주는 지도와 같습니다."
          :desc="[
            '<b><span class=\'ganji-txt five03\'>목(木)</span>, <span class=\'ganji-txt five01\'>화(火)</span>, <span class=\'ganji-txt five05\'>토(土)</span>, <span class=\'ganji-txt five04\'>금(金)</span>, <span class=\'ganji-txt five02\'>수(水)</span></b>', 
            '이 다섯 가지 기운이 내 사주 안에 얼마나 어떻게 담겼는지를 나타내요.',
            ]"
          :bottom="[
            '“나는 어떤 기운에 가까울까?” 강한 기운과 부족한 기운을 보면', 
            '스스로를 어떻게 보완하면 좋을지도 알 수 있어요.',
            ]"
        />
        <div class="summ-body__start data-sec-01-box">
          <div class="date-pro-root-box summ-start">
            <SajuFiveStart
              ref="starRef"
              :birthData="birthData"
              :birthEightTxt="birthEightTxt"
            />
          </div>

        </div>
      </section>
    </div>
  </VCol>
</VRow>
</template>

<style lang="scss" scoped>
.compare-label {
  font-size: 12px;
  font-weight: 700;
  color: #f27647;
  padding: 12px 0 4px;
  border-top: 1px dashed #ddd;
  margin-top: 12px;
}

// 상위 컨테이너에서 가로 스크롤 방지
.summ-card {
  overflow-x: hidden;
}

.summ-body {
  overflow-x: hidden;
}

// SajuBirth, SajuFiveStart wrapper만 가로 스크롤
.summ-body__saju,
.summ-body__start {
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 100%;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}
</style>